import { get, handleError } from '@/lib/http-adapter';
import { ClassGroup } from '@/state/class-groups';

export const getClassGroups = async (queryParams?: {
  include_classes: boolean;
}) => {
  try {
    const response = await get<{
      class_groups: ClassGroup[];
    }>('/public/class-groups', { params: queryParams });

    return response?.class_groups;
  } catch (error) {
    handleError(error);
  }
};
